import React from 'react'
import AITestContext from '../../../contexts/AITestContext'
import SchoolIcon from '@mui/icons-material/School';
import './aitest.css'


export const TestCollege = () => {

  const {
    school,
    setShowTestSchool,
  } = React.useContext(AITestContext);

const onShowSchool = () => {
  console.log("TestCollege")
  setShowTestSchool(true)
}

  return (
      <div>
          <div style = {{marginBottom:'10px'}}>
            <SchoolIcon className="languageIcon" onClick={onShowSchool}/>
            <label className='navbarFonts' style={{paddingLeft: '5px', fontWeight:'700'}}><span style = {{fontSize:'20px'}}>{school}</span></label>
        </div>
      </div>
    )
  }
